import { Button, Card } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useState } from "react";
import Message from "../message";

function MapResults() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [map_results, setMap_results] = useState({ q: "", lat: "", long: "" });
  const [status_map_results, setStatus_map_results] = useState("");
  const [mapLocation, setMapLocation] = useState({ location: "" });

  const submit_map_results = async () => {
    setStatus_map_results("");

    if (map_results["q"] === "") {
      setStatus_map_results("Enter a query!");
    } else if (map_results["lat"] === "") {
      setStatus_map_results("Enter latitude!");
    } else if (map_results["long"] === "") {
      setStatus_map_results("Enter longitude!");
    } else {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          q: map_results["q"],
          lat: map_results["lat"].toString(),
          long: map_results["long"].toString(),
        }),
      };

      try {
        const response = await fetch(
          apiServer + "api/serpapi/maps",
          requestOptions
        );
        const map_results_id = await response.json();
        const map_results_status = map_results_id.detail
          ? map_results_id.detail
          : map_results_id;
        setStatus_map_results(map_results_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  const location_to_lat_long = async () => {
    if (mapLocation.location !== "") {
      try {
        const map_lat_long_res = await fetch(
          apiServer + "api/helper/lat_long/" + mapLocation.location
        );
        const map_lat_long = await map_lat_long_res.json();

        if (map_lat_long) {
          if (map_lat_long.lat) {
            setMap_results({
              ...map_results,
              lat: map_lat_long.lat,
              long: map_lat_long.long,
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      setStatus_map_results("Enter a location!");
    }
  };
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TextField
        style={{ marginTop: "15px", width: "100%" }}
        value={map_results.q}
        onChange={(e) => setMap_results({ ...map_results, q: e.target.value })}
        label="Query"
        variant="filled"
      />
      <TextField
        style={{ marginTop: "2px", width: "100%" }}
        value={map_results.lat}
        onChange={(e) =>
          setMap_results({ ...map_results, lat: e.target.value })
        }
        label="Lat"
        variant="filled"
      />
      <TextField
        style={{ marginTop: "2px", width: "100%" }}
        value={map_results.long}
        onChange={(e) =>
          setMap_results({ ...map_results, long: e.target.value })
        }
        label="Long"
        variant="filled"
      />
      <Button
        variant="primary"
        style={{ marginTop: "20px", width: "100%" }}
        onClick={() => submit_map_results()}
      >
        Submit
      </Button>

      <Card
        style={{
          backgroundColor: "lightblue",
          padding: "10px",
          marginTop: "10px",
        }}
        className="shadow p-3 rounded"
      >
        <TextField
          label="Location"
          value={mapLocation.location}
          onChange={(e) =>
            setMapLocation({
              ...mapLocation,
              location: e.target.value,
            })
          }
          InputProps={{
            endAdornment: (
              <Button variant="outline" onClick={() => location_to_lat_long()}>
                send
              </Button>
            ),
          }}
        />
      </Card>
      <div style={{ marginTop: "20px" }} />
      {Message(status_map_results, setStatus_map_results)}
    </div>
  );
}

export default MapResults;
